/** @module csi/action/ImageReplaceWizard */
define([
	"dojo/_base/declare",
	"csi/wizard/FinishController",
	"csi/wizard/Widget",
	"csi/xml"
], function(declare,FinishController,WizardWidget,xml) {

	var ACTION_UNLINK = "ImageReplaceUnlink";
	
	var _ImageReplaceUnlinkController = declare(FinishController, {
		/**
		 * Add indication of "Unlink" button clicked and then continue same way as "Finish" button does
		 */
		process: function() {
			this.getOriginalController().bUnlink = true;
			this.inherited(arguments);
		}
	});
	
	return declare(WizardWidget, {
		_actionControllers: {
			ImageReplaceUnlink: _ImageReplaceUnlinkController
		},

		/**
		 * Show/Hide "Unlink Image" button
		 * @param {sting} idAction
		 * @return {boolean} - return false to hide the button 
		 */
		canShowButton: function(idAction) {
			if (idAction == ACTION_UNLINK) {
				var ac = this.getSourceController();
				if (!xml.isValidURL(ac.getAction().unlinkURL)){
					return false;
				}
				var page = this.getSelectedPage();
				var index = this.getIndexOfPage(page);
				var realizedIndex = ac.getWizardRealizedPageIndex(this, index);

				var bLast = (realizedIndex == (ac.getWizardNumberOfRealizedPages(this) - 1));

				return bLast;
			}

			return this.inherited(arguments);
		}
	});
});